import {
  Button,
  chakra,
  FormControl,
  FormLabel,
  Input,
  Stack,
} from "@chakra-ui/react";
import * as React from "react";

export const ResetForm = ({ onSubmit, ...rest }) => {
  const [email, setEmail] = React.useState("");
  return (
    <chakra.form
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit(email);
      }}
      {...rest}
    >
      <Stack spacing="6">
        <FormControl id="email">
          <FormLabel>Email address</FormLabel>
          <Input
            name="email"
            type="email"
            autoComplete="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </FormControl>
        <Button
          type="submit"
          colorScheme="red"
          color="white"
          size="lg"
          fontSize="md"
        >
          Continue
        </Button>
      </Stack>
    </chakra.form>
  );
};
